import { Component, Input, ViewChild } from '@angular/core';
import { TopupComponent } from '@teem/wallets-module/modals/topup/topup.component';
import { TopupService } from '@teem/wallets-module/modals/topup/topup.service';


@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
	styleUrls: ['./banner.component.scss']
})

export class BannerComponent {
  @Input() walletStatus: string = 'old';
  isVisible: boolean = true;
  constructor(private topupService: TopupService) {}
  closeBanner() {
    this.isVisible = false;
  }


  @ViewChild(TopupComponent) modalComponent!: TopupComponent;
  
    openTopUpModal() {
      this.topupService.openPopup();
    }
}